import { IDisclaimerServiceMock } from "@/services/saldosonline/disclaimer/disclaimer.type";

export const mockDisclaimerService = (): IDisclaimerServiceMock => ({
  getDisclaimer: jest.fn(),
});
